<template>
  <div
    class="complete-content"
    :style="containerStyle"
  >
    <div
      class="close-btn"
      @click="close"
    >
      <i class="el-icon-close"></i>
    </div>
    <el-scrollbar
      ref="bar"
      wrap-class="scrollbar-wrapper"
      style="height: 100%;display: flex;flex-direction: column;"
    >
      <!-- 滚动条包裹部分 -->
      <div
        class="scroll-inner"
        style="width: 480px"
      >
        <video-list></video-list>
        <go-on-list v-if="goOnListVisible()"></go-on-list>
        <btn-list></btn-list>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  components: {
    VideoList: () => import('./completeContent/videoList'),
    GoOnList: () => import('./completeContent/goOnList'),
    BtnList: () => import('./completeContent/btnList')
  },
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    doingTasks: {
      type: Promise,
      default() {
        return Promise.resolve();
      }
    }
  },
  data() {
    return {
      defaultMaxHeight: 665,
      containerStyle: {
        maxHeight: '665px'
      }
    };
  },
  computed: {
    ...mapGetters({
      viewDict: 'views/dict'
    })
  },
  mounted() {
    this.updateMaxHeight(this.getMaxHeight());
    this.listenWindowResize();
    this.$nextTick(() => {
      this.$refs.bar.update();
    });
    let rName = (this.$route.path || '').slice(1);
    // 参数1 事件名
    // 参数2 事件携带数据
    this.$sensors.track('toolFinish', {
      tool_type: (this.viewDict[rName] || {}).text || '',
      content_number: this.items.length || 0
    });
  },
  beforeDestroy() {
    this.stopListenWindowResize();
  },
  methods: {
    getItems() {
      return this.items;
    },
    close() {
      this.$modal.hide('completeModal');
    },
    updateMaxHeight(num = 0) {
      this.containerStyle.maxHeight = `${num}px`;
    },
    listenWindowResize() {
      window.addEventListener('resize', this.onWindowResize);
    },
    onWindowResize() {
      this.updateMaxHeight(this.getMaxHeight());
      this.$nextTick(() => {
        this.$refs.bar.update();
      });
    },
    stopListenWindowResize() {
      window.removeEventListener('resize', this.onWindowResize);
    },
    getMaxHeight() {
      return window.innerHeight - 80;
    },
    goOnListVisible() {
      if (this.$route.path === '/videoConverter') {
        return this.items.length === 1 && this.items[0].origin.outputFormat === 'MP4';
      }
      return this.items.length === 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import './modal';
.complete-content {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  width: 480px;
  overflow: visible;
  overflow-y: auto;
  // background-color: #fff;
  display: flex;
  flex-direction: column;
}
.close-btn {
  position: absolute;
  left: calc(30px + 100%);
  top: 0;
  color: #fff;
  font-size: 20px;
  background: rgba(#fff, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: rgba(#fff, 0.6);
  &:hover {
    background: rgba(#000, 0.4);
  }
}
.close-btn > .el-icon-close {
  color: rgba(#fff, 0.8);
}
.scroll-container {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.scroll-wrapper {
  display: block;
  overflow: auto;
}
.thumb {
  position: absolute;
  right: 0;
  top: 0;
  width: 8px;
  background-color: #d4d6dc;
  border-radius: 8px;
  user-select: none;
}
</style>
